"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var InputWrapper = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store, appendix = _a.appendix, children = _a.children;
    return (store.hidden
        ? (react_1.default.createElement("input", { type: "hidden", name: store.name, value: store.value })) : (react_1.default.createElement("div", { className: "estimateForm-InputWrapper" },
        react_1.default.createElement("div", { className: "estimateForm-InputWrapper_LabelWrapper" },
            react_1.default.createElement("label", { htmlFor: store.id },
                react_1.default.createElement("span", { className: "estimateForm-InputWrapper_LabelText" }, store.label),
                store.necessary &&
                    react_1.default.createElement("span", { className: "estimateForm-InputWrapper_NecessaryLabel" }, "\u203B\u5FC5\u9808"),
                !store.necessary &&
                    react_1.default.createElement("span", { className: "estimateForm-InputWrapper_OptionalLabel" }, "\u4EFB\u610F")),
            store.description &&
                react_1.default.createElement("p", { dangerouslySetInnerHTML: { __html: store.description }, className: "estimateForm-InputWrapper_Description" })),
        react_1.default.createElement("div", { className: "estimateForm-InputWrapper_InnerBox" },
            react_1.default.createElement("div", { className: "estimateForm-InputWrapper_Input" }, store.disabled
                ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "estimateForm-InputWrapper_InputtedValue" }, store.valueText),
                    react_1.default.createElement("input", { type: "hidden", name: store.name, value: store.value }))) : (children)),
            store.valid && react_1.default.createElement("i", { className: "estimateForm-InputWrapper_CheckMark" })),
        appendix)));
});
exports.default = InputWrapper;
